export enum ElementTestId {
  STOCK_PANEL_SEARCH_BAR = 'STOCK_PANEL_SEARCH_BAR',
  ADD_ITEM_BAR_MY_UPLOADS = 'ADD_ITEM_BAR_MY_UPLOADS',
  ADD_ITEM_BAR_MEDIA = 'ADD_ITEM_BAR_MEDIA',
  ADD_ITEM_BAR_AI_IMAGES = 'ADD_ITEM_BAR_AI_IMAGES',
  ADD_ITEM_BAR_AI = 'ADD_ITEM_BAR_AI',
  ADD_ITEM_BAR_BACKGROUND = 'ADD_ITEM_BAR_BACKGROUND',
  ADD_ITEM_BAR_LAYOUT = 'ADD_ITEM_BAR_LAYOUT',
  ADD_ITEM_BAR_TEXT = 'ADD_ITEM_BAR_TEXT',
  ADD_ITEM_BAR_RECORD = 'ADD_ITEM_BAR_RECORD',
  STOCK_PANEL_CAROUSEL_SHAPES = 'STOCK_PANEL_CAROUSLE_SHAPES',
  STOCK_PANE_LAZY_GRID = 'STOCK_PANE_LAZY_GRID',
  POSTER_EDITOR_WEB_BOTTOM_BAR_PLAY_PAUSE_BUTTON = 'POSTER_EDITOR_WEB_BOTTOM_BAR_PLAY_PAUSE_BUTTON',

  // Website Builder
  WEBSITE_BUILDER_HEADER_NAV_BAR = 'WEBSITE_BUILDER_HEADER_NAV_BAR',
  WEBSITE_BUILDER_SAVE_BUTTON = 'WEBSITE_BUILDER_SAVE_BUTTON',
}
